import styled from 'styled-components';

const StyledIcon = styled.div<{
	$icon: string;
	$width?: number;
	$height?: number;
	$color?: string;
}>`
	width: ${({ $width }) => $width || 20}px;
	min-width: ${({ $width }) => $width || 20}px;
	height: ${({ $height }) => $height || 20}px;
	min-height: ${({ $height }) => $height || 20}px;
	mask-position: center;
	mask-repeat: no-repeat;
	mask-image: url(${({ $icon }) => $icon});
	mask-size: ${({ $width, $height }) => `${$width}px ${$height}px`};
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-image: url(${({ $icon }) => $icon});
	-webkit-mask-size: ${({ $width, $height }) => `${$width}px ${$height}px`};
	background-color: ${({ $color }) => $color || '#ffffff'};
	transition: background-color 0.3s ease;
`;

export { StyledIcon };
